import React, { memo } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import type { KanbanColumn } from 'types/kanban';
import DroppableColumn, { type DroppableColumnProps } from '../DroppableColumn';
import styles from './SortableListWrapper.module.scss';

export interface SortableListWrapperProps extends DroppableColumnProps {
  column: KanbanColumn;
}

function SortableListWrapper(props: SortableListWrapperProps) {
  const { column } = props;
  const { setNodeRef, transform, listeners, attributes, isDragging } =
    useSortable({
      id: column.id,
      data: { type: 'list', column },
    });

  const style = transform
    ? {
        transform: CSS.Transform.toString(transform),
      }
    : undefined;

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={isDragging ? styles.listDragging : ''}
    >
      <DroppableColumn
        {...props}
        sortableListeners={listeners}
        sortableAttributes={attributes}
      />
    </div>
  );
}

export default memo(SortableListWrapper);
